import { styled, css } from "styled-components";

const Base = css`
  column-gap: ${({ theme }) => theme.space.gridColumnGap};
  display: grid;
  grid-template-columns: repeat(6, 1fr);
`;

export const GridLayout = styled.div`
  ${Base}

  ${({ theme }) => theme.breakpoints.up("desktop")} {
    grid-template-columns: repeat(18, 1fr);
  }
`;

export default GridLayout;
